import { COLORS } from "../localConstants.ts";

export const getColorByIndex = (index: number) => {
    const colorsArray = Object.values(COLORS);

    return colorsArray[index % colorsArray.length];
};
